<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33887 35.5405L35.5833 35.8039"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M7.73535 18.8235V35.8042"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M32.1865 29.0886L32.1865 35.8809"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M10.4521 29.0886L10.4521 35.8809"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M10.4521 26.2961L10.4521 27.6546"
      :stroke="fill"
      stroke-width="1.31523"
      stroke-linejoin="round"
    />
    <path
      d="M32.1865 26.2961L32.1865 27.6546"
      :stroke="fill"
      stroke-width="1.31523"
      stroke-linejoin="round"
    />
    <path
      d="M32.1865 18.8235L32.1865 24.9365"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <rect
      x="14.3057"
      y="17.5947"
      width="12.8"
      height="12.8"
      fill="#D1D7DF"
    />
    <path
      d="M28.0195 7.53735H31.2195V13.4802L28.0195 10.7374V7.53735Z"
      fill="#D1D7DF"
    />
    <path
      d="M14.4268 29.9491V17.7839H26.5919V29.9491H14.4268Z"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M20.5088 18.1436L20.5088 30.3696"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M26.7539 23.8665L14.5278 23.8665"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M27.999 10.8929V7.8811H31.199V13.8811"
      :stroke="fill"
      stroke-linejoin="round"
    />
    <path
      d="M4 17.1258L6.37729 20.1823L19.9618 8.65225L33.5464 20.1823L35.584 17.805L19.9618 3.88086L4 17.1258Z"
      :stroke="fill"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsVerticalsHouseLoans'
})

defineProps({
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  },

  width: {
    type: String,
    default: '40'
  },

  height: {
    type: String,
    default: '40'
  }
})
</script>
